import { render, staticRenderFns } from "./PublishDetailsModal.vue?vue&type=template&id=ca205e5a&scoped=true"
import script from "./PublishDetailsModal.vue?vue&type=script&lang=js"
export * from "./PublishDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PublishDetailsModal.vue?vue&type=style&index=0&id=ca205e5a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca205e5a",
  null
  
)

export default component.exports